module.exports = __webpack_public_path__ + "img/product-1-wifi.c6ee610d.png";